import {
    createApi,
    fetchBaseQuery
  } from "@reduxjs/toolkit/query/react";

const APIM_SUBSCRIPTION_VALUE = process.env.REACT_APP_AI_ASSISTANT_APIM_SUBSCRIPTION_VALUE
const BASE_URL = process.env.REACT_APP_AI_ASSISTANT_API_URL

export interface AgentAssistantQueryParam {
    conversation_id: string | null,
    message: string
}

export const agentAssistantApi = createApi({
    reducerPath: "agentAssistantApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: async (headers, { getState }) => {
            headers.set('Content-Type', `application/json`)
            headers.set('Ocp-Apim-Subscription-Key', `${APIM_SUBSCRIPTION_VALUE}`)
            return headers
        }
    }),
    tagTypes: ["Chat"],
    endpoints: (builder) => ({
        chat: builder.mutation({
            query: (body: AgentAssistantQueryParam) => ({
                url: `/chat`,
                method: 'POST',
                body
            })
        })
    })
})
    
export const {
    useChatMutation
  } = agentAssistantApi;